<template>
    <div class="popup-overlay" v-if="showPopup">
      <div class="popup-container">
        <h2 class="popup-header">
            <span v-if="showQRCode">Two-Factor Authentication Setup</span>
            <span v-else>Two-Factor Authentication Code</span>
            </h2>
        <div class="popup-content">
            <div v-if="showQRCode" class="qr-container">
            <p class="description">Using your preferred authenticator app, scan the QR code below within the app, then enter the code generated into the verify field below.</p>
                <img :src="qrCodeValue" alt="QR Code" class="qr-code" />
            </div>
            <div class="field-container">
                <label v-if="showQRCode" for="otp-field">Verify OTP</label>
                <label v-else class="otp-description" for="otp-field">Enter the code from the two-factor app configured on your mobile device</label>
                <div class="input-container">
                <input type="number" id="otp-field" v-model="otp" placeholder="Enter 6 digit OTP" class="otp-input" @input="inputChange"/>
                <div v-if="fieldErrorMessage" class="error-message">{{fieldErrorMessage}}</div>
                </div>
            </div>
        </div>
        <div class="popup-footer">
            <button @click="closePopup" class="close-button">Cancel</button>
            <button @click="verifyOtp" :disabled="otp.length!==6||loading" class="verify-button">
                <span v-if="!loading">Verify</span>
                <span v-else>Verifying...</span>
            </button>
        </div>
      </div>
    </div>
</template>
<script>

import { VERIFYOTP } from '../store/actions.type'
export default {
  props: {
    showPopup: Boolean,
    closePopup: Function,
    loginResponse: Object
  },
  data () {
    return {
      otp: '',
      qrCodeValue: '',
      showQRCode: false,
      loading: false,
      fieldErrorMessage: null
    }
  },
  watch: {
    loginResponse: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          if (newVal.qrCodeUrl) {
            this.qrCodeValue = newVal.qrCodeUrl
          }
          this.showQRCode = !newVal.is2FAEnabled
        }
      }
    }
  },
  methods: {
    verifyOtp () {
    // Add OTP verification logic here
      this.loading = true
      this.$store.dispatch(VERIFYOTP, { username: this.loginResponse.username, password: this.loginResponse.password, otp_code: this.otp }).then(() => {
        if (this.$store.state.auth.errors == null) {
          this.$router.push(`/`)
        }
      }).catch((errorResponse) => {
        if (errorResponse.data.error === 'Invalid OTP code.') {
          this.fieldErrorMessage = errorResponse.data.error
        }
      }).finally(() => {
        this.loading = false
      })
    },
    inputChange () {
      this.fieldErrorMessage = null
    }
  },
  destroyed () {
    this.otp = ''
    this.qrCodeValue = ''
    this.fieldErrorMessage = ''
    this.loading = false
    this.showQRCode = false
  }
}
</script>
<style scoped>
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .popup-container {
    width:500px;
    background: white;
    padding: 25px;
    border-radius: 8px;
  }
  .popup-header{
    font-size:1.8rem;
    line-height: 1.8rem;
  }
  .popup-content{
    width:100%;
    display:flex;
    padding:20px 0;
    flex-direction: column;
    row-gap: 10px;
  }
  .popup-footer{
    display: flex;
    justify-content: flex-end;
    gap:20px
  }
  .qr-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .qr-code {
    margin:0 auto;
    width: 250px;
    height: 250px;
  }
  .field-container{
    height: 100%;
  }
  .field-container label{
    display: block;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
  }
  .otp-input {
    width: 100%;
    display: block;
    border: 1px solid black;
    padding: 8px 10px;
    border-radius: 8px;
  }
  .description{
    font-size: 18px;
    margin-bottom:0
  }
  .input-container{
    position: relative;
  }
  .error-message{
    color: red;
    position: absolute;
    font-size: 12px;
    bottom:-20px;
    padding-top: 2px
  }
  .verify-button {
    padding: 8px 16px;
    cursor: pointer;
    color: white;
    border: none;
    border-radius: 5px;
    background-color: #6aa58b !important;
    border-color: #6aa58b !important;
  }
  .verify-button:disabled {
    opacity: 0.6 !important;
    cursor: not-allowed;
  }
  .close-button {
    padding: 8px 16px;
    background: gray;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
  }
/* Firefox */
   input[type=number] {
   -moz-appearance: textfield;
   }
  </style>
